import ParseHelper from './ParseHelper';

export const requestCollectionsList = async () =>
  ParseHelper.CloudRun('collection-list');
export const requestCreateCollection = async (collection) =>
  ParseHelper.CloudRun('collection-create', { ...collection });
export const requestUpdateCollection = async (collection) =>
  ParseHelper.CloudRun('collection-update', { ...collection });
export const requestDeleteCollection = async (collectionId) =>
  ParseHelper.CloudRun('collection-delete', { collectionId });

export const requestLayersList = async (collectionId) =>
  ParseHelper.CloudRun('layer-list', { collectionId });
export const requestCreateLayer = async (layer) =>
  ParseHelper.CloudRun('layer-create', { ...layer });
export const requestUpdateLayer = async (layer) =>
  ParseHelper.CloudRun('layer-update', { ...layer });
export const requestDeleteLayer = async (layer) =>
  ParseHelper.CloudRun('layer-delete', { layerId: layer.id });

export const requestUpdateTrait = async (trait) =>
  ParseHelper.CloudRun('trait-update', { ...trait });
export const requestDeleteTrait = async (trait) =>
  ParseHelper.CloudRun('trait-delete', { traitId: trait.id });
